import { filter, type ImageField, type PrismicDocument, type RichTextField, type TitleField } from '@prismicio/client'
import type * as Prismic from '@prismicio/client'

export const dhlExtraPromotionOneOffType = 'loyalty-promotion-oneoff'

export const includeAcceptTag = (): string => filter.at('document.tags', ['accept'])
export const excludeAcceptTag = (): string => filter.not('document.tags', ['accept'])

export const dhlExtraPromotionOneOffPredicate: string = filter.at('document.type', dhlExtraPromotionOneOffType)
export const documentUidPredicate = (uid: string): string => filter.at('document.uid', uid)

export type PrismicPromotionDto = PrismicDocument<{
  body: Prismic.SliceZone
  title: TitleField
  description: RichTextField
  promotion_body: RichTextField
  promotion_image: ImageField
}>

export type PrismicPromotion = {
  uid: string | null
  title: string
  description: RichTextField
  body: RichTextField
  image: ImageField
  sliceZone: Prismic.SliceZone
}

export type PrismicPromotionParams = {
  prismicEndpoint: string
  lang: string
}

export type PrismicError = Prismic.PrismicError<unknown>

export const unwrapPrismicPromotion = (promotion: PrismicPromotionDto): PrismicPromotion => ({
  uid: promotion.uid,
  title: promotion.data.title[0]?.text ?? '',
  description: promotion.data.description,
  body: promotion.data.promotion_body,
  image: promotion.data.promotion_image,
  sliceZone: promotion.data.body,
})
